import React from "react";

function BCDevHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-9 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  Blockchain Development Company
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    With expertise in over 40 blockchain protocols, we’re
                    leading the way to a web3 future through our advanced
                    blockchain development services.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BCDevHero;
